import SessionModel from 'src/pods/sessions/models/SessionModel';
import { IUpdateable } from 'src/pods/system/interfaces';

import { updater } from 'src/utils/ObjectUpdater';

export default class JournalModel implements IUpdateable<JournalModel> {
    public createdAt!: string;
    public description!: string;
    public id!: number;
    public sessionID!: number;
    public submittedAt!: string;
    public updatedAt!: string;
    public session!: SessionModel;

    constructor(args?: Partial<JournalModel>) {
        Object.assign(this, args);
    }

    public update(obj: Partial<JournalModel>): JournalModel {
        return updater.update(this, obj);
    }
}
